import { HttpClient, httpResource } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PaginatedJob, PaginatedObjects } from '../../utils/models/pagination.models';
import { Job, Tool, ToolJob } from '../../utils/models/tool.models';
import { Toolchain, ToolchainJob } from '../../utils/models/toolchain.models';

@Injectable({ providedIn: 'root' })
export class CapabilityService {
  private readonly http = inject(HttpClient);

  readonly tools = httpResource<Tool[]>(() => 'external/tools');
  readonly toolchains = httpResource<Toolchain[]>(() => 'external/toolchains');

  getToolJobs(toolId: number, page: number, perPage: number): Promise<PaginatedObjects<ToolJob>> {
    return firstValueFrom(
      this.http.get<PaginatedObjects<ToolJob>>('external/tools/jobs', {
        params: { tool_id: toolId, page, per_page: perPage },
      })
    );
  }

  getToolchainJobs(
    toolchainId: number,
    page: number,
    perPage: number
  ): Promise<PaginatedObjects<ToolchainJob>> {
    return firstValueFrom(
      this.http.get<PaginatedObjects<ToolchainJob>>('external/toolchains/jobs', {
        params: { toolchain_id: toolchainId, page, per_page: perPage },
      })
    );
  }

  getJobs(page: number, perPage: number): Promise<PaginatedObjects<Job>> {
    return firstValueFrom(
      this.http.get<PaginatedJob>('external/jobs', { params: { page, per_page: perPage } })
    );
  }

  deleteAllJobs(): Promise<{ success: boolean; msg: string }> {
    return firstValueFrom(this.http.delete<{ success: boolean; msg: string }>('external/jobs'));
  }
}
